import { useEffect } from 'react';
import { GameId } from '@bg-shared/enums';
import { feimSettingsStore } from '@bg-shared/business/FEIMSettings';
import { partnerSettingsStore } from '@bg-shared/business/PartnerSettings';
import { webAPIIntegration } from '../webAPIIntegration';

export const useGameWebAPIIntegration = (gameID: GameId) => {
    useEffect(() => {
        feimSettingsStore.reset();

        webAPIIntegration(partnerSettingsStore.webIntegrationType, (api) => {
            api.navigate(gameID);
            api.gameLoadStarted();
        });
    }, [gameID]);
};
